import { AccessorsMutatorsDecorator, Model } from "../../helpers";

export class ReservationNote extends Model {
    
}

AccessorsMutatorsDecorator('id', 'user', 'reservation', 'note', 'status', 'created_at', 'updated_at')(ReservationNote);


// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-note.model.js